import { render } from "./PushNotificationServiceParameter.vue?vue&type=template&id=13869c4c&scoped=true"
import script from "./PushNotificationServiceParameter.vue?vue&type=script&lang=ts"
export * from "./PushNotificationServiceParameter.vue?vue&type=script&lang=ts"

import "./PushNotificationServiceParameter.vue?vue&type=style&index=0&id=13869c4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13869c4c"

export default script